import React from 'react';
import dayjs from 'dayjs';

import { getDisplayName } from '../../utils/getDisplayName';
import { sortByDate, sortByText } from '../../utils/tableSorters';

export const LOCATION_TABLE_SCROLL_X = 1080;

export const formatLocationAddress = (record) => {
  if (record?.name === '주문고객') {
    return '수요자 통합 거점';
  }

  return `${record?.address || ''} ${record?.addressDetail || ''}`.trim() || '-';
};

export const buildLocationColumns = () => [
  {
    title: '거점명',
    key: 'name',
    dataIndex: 'name',
    width: 180,
    sorter: sortByText((record) => record.name),
  },
  {
    title: '주소',
    key: 'address',
    dataIndex: 'address',
    width: 360,
    ellipsis: true,
    sorter: sortByText((record) => formatLocationAddress(record)),
    render: (_, record) =>
      record.name === '주문고객' ? (
        <span style={{ fontStyle: 'italic', color: 'gray' }}>{formatLocationAddress(record)}</span>
      ) : (
        formatLocationAddress(record)
      ),
  },
  {
    title: '등록일시',
    key: 'createdAt',
    dataIndex: 'createdAt',
    width: 170,
    align: 'center',
    sorter: sortByDate((record) => record.createdAt),
    render: (_, record) => dayjs(record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: '등록자',
    key: 'createdBy',
    dataIndex: 'createdBy',
    width: 100,
    align: 'center',
    sorter: sortByText((record) => getDisplayName(record.createdBy)),
    render: (_, record) => getDisplayName(record.createdBy),
  },
  {
    title: '수정일시',
    key: 'updatedAt',
    dataIndex: 'updatedAt',
    width: 170,
    align: 'center',
    sorter: sortByDate((record) => record.updatedAt),
    render: (_, record) => dayjs(record.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: '수정자',
    key: 'updatedBy',
    dataIndex: 'updatedBy',
    width: 100,
    align: 'center',
    sorter: sortByText((record) => getDisplayName(record.updatedBy)),
    render: (_, record) => getDisplayName(record.updatedBy),
  },
];
